export const emptyText = `It appears no approval units have been assigned yet. To assign one, please click "Add new."`;
